export default "__VITE_ASSET__BgvjAoz4__"